import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnInit,
  output,
  signal,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

import { NgxMaskDirective } from 'ngx-mask';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { materialModules } from '../../../core/constants/mat-modules';

import { WaitingListFormService } from './waiting-list-form.service';
import { PortalDataService } from '../portal-data.service';
import { PriorityType, PriorityTypeDetails } from '../../../core/enum/EPriorityType';
import { EntryPostBody } from '../../../core/interfaces';
import { CountryPhonePipe } from '../../../shared/pipes';
import { PhoneCountryInputComponent } from '../../../shared/components/phone-country-input/phone-country-input.component';

@Component({
  selector: 'madero-waiting-list',
  templateUrl: './waiting-list.component.html',
  styleUrl: './waiting-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ...materialModules,
    ReactiveFormsModule,
    NgxMaskDirective,
    CountryPhonePipe,
    PhoneCountryInputComponent,
    TranslatePipe,
  ],
  providers: [WaitingListFormService],
})
export class WaitingListComponent implements OnInit {
  readonly portalDataService = inject(PortalDataService);
  readonly #waitingListFormService = inject(WaitingListFormService);

  get branch() {
    return this.portalDataService.branch()!;
  }

  return = output<void>();
  joinedWaitingList = output<EntryPostBody>();

  priorityTypesEnum = PriorityType;
  priorityTypesDetails = PriorityTypeDetails;
  priorityTypes = signal(Object.keys(PriorityTypeDetails).map((k) => Number(k) as PriorityType));
  branchAllowPet = computed<boolean>(() => this.branch.pet);
  lgpdAccepted = signal(localStorage.getItem('lgpd') === 'true');

  get priorityTypesDescription(): string | null {
    return this.#waitingListFormService.mapPriorityTypesToDescription();
  }

  get form() {
    return this.#waitingListFormService.form;
  }

  get priorities() {
    return this.form.controls.priorities;
  }

  ngOnInit(): void {
    this.#waitingListFormService.initializeForm();
  }

  onLgpdAccepted(): void {
    localStorage.setItem('lgpd', 'true');
  }

  onCheckPriorityChange(event: MatCheckboxChange): void {
    const priority = Number(event.source.value) as PriorityType;
    const priorityTypes = this.form.getRawValue().priorities.priorityTypes;

    if (event.checked) {
      priorityTypes.push(priority);
    } else {
      const indexToRemove = priorityTypes.findIndex((t) => t === priority);
      priorityTypes.splice(indexToRemove, 1);
    }

    this.priorities.controls.priorityTypes.setValue(priorityTypes);
  }

  onSubmitEntry(): void {
    const body = this.#waitingListFormService.getWaitingListEntryBody(this.portalDataService.branch()!);
    this.joinedWaitingList.emit(body);
  }
}
